import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ScrollArea } from '~/components/ui/scroll-area'
import { AppSidebar } from '../../components/new/navigation/app-sidebar'
import { SidebarInset, SidebarProvider } from '../../components/ui/sidebar'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return (
    <div className="h-screen max-h-screen overflow-hidden">
      <ScrollArea className="h-full" scrollBarClassName="mr-px">
        <SidebarProvider>
          <AppSidebar />

          <SidebarInset className="bg-sidebar m-2 ml-0 p-4 rounded-lg overflow-hidden">
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      </ScrollArea>
    </div>
  )
}
